import { render, staticRenderFns } from "./EditProcessor.vue?vue&type=template&id=c9d5f252"
import script from "./EditProcessor.vue?vue&type=script&lang=js"
export * from "./EditProcessor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports